import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	ViewRef,
	HostListener,
	Inject
}
from '@angular/core';
import {trigger, transition, style, animate,} from "@angular/animations";
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
// Material
import { MatDialog, MatDialogRef, MatTabChangeEvent, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { FunctionPublic } from '../../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../../dung-chung/__services/dung-chung.service';
import { LayoutUtilsService } from '../../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../../core/_base/layout';
import { DeNghiMuaHangPageService } from '../de-nghi-mua-hang-page-service/de-nghi-mua-hang-page.service';
import { DuKienSanXuatService } from 'app/views/pages/nfc/ke-hoach/du-kien-san-xuat/du-kien-san-xuat-service/du-kien-san-xuat.service';
//Model
import { CommonConFig } from '../../../../dung-chung/__model/common_config.model';
import { TimKiemNangCaoListComponent } from '../../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { DeNghiMuaHang, DeNghiMuaHangCT, FileImport } from '../de-nghi-mua-hang-page-model/de-nghi-mua-hang-page.model';
import { AddHangHoaComponent } from '../add-hang-hoa-dialog/add-hang-hoa-dialog.component';
import { KeHoachMuaHang } from '../../../ke-hoach-mua-hang/ke-hoach-mua-hang-model/ke-hoach-mua-hang.model';
import { LichSuNhanHangDialogComponent } from '../lich-su-nhan-hang-list-dialog/lich-su-nhan-hang-list-dialog.component';
import { LichSuMuaHangDialogComponent } from '../lich-su-mua-hang-list-dialog/lich-su-mua-hang-list-dialog.component';
import { KhKeHoachSanXuatDuKienNhapXuatInteraction, KhKeHoachSanXuatInteraction } from 'app/views/pages/nfc/san-xuat/ke-hoach-san-xuat/ke-hoach-san-xuat-model/ke-hoach-san-xuat.model';
import { KDDatHangEditComponent } from 'app/views/pages/nfc/kinh-doanh/kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { KDDatHang } from 'app/views/pages/nfc/kinh-doanh/kd-dat-hang/kd-dat-hang-model/kd-dat-hang.model';

@Component({
	selector: 'm-de-nghi-mua-hang-page-add-edit-dialog',
	templateUrl: './de-nghi-mua-hang-page-add-edit-dialog.component.html',
	styleUrls: ['../de-nghi-mua-hang-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
	animations: [
		trigger(
		  'addAnimation', [
			transition(':enter', [
			  style({transform: 'translateX(100%)', opacity: 0}),
			  animate('800ms', style({transform: 'translateX(0)', opacity: 1, 'overflow-x': 'hidden'}))
			]),
			transition(':leave', [
			  style({transform: 'translateX(0)', opacity: 1}),
			  animate('800ms', style({transform: 'translateX(100%)', opacity: 0}))
			])
		  ]
		),
	]
})

export class DeNghiMuaHangPageAddEditDialogComponent implements OnInit {

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport: ElementRef;
	@ViewChild('fileUpload', { static: true }) fileUpload;
	@ViewChildren('focusDetail') focusDetail;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: 'MaHang',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'SoLuong',
			displayName: 'SL',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'MOQ',
			displayName: 'MOQ',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'SoLuongTK',
			displayName: 'Tồn kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'NgayCanTu',
			displayName: 'Ngày cần từ ngày',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'NgayCanDen',
			displayName: 'Ngày cần đến ngày',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'GiaDuKien',
			displayName: 'Giá dự kiến (VND)',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'ThanhTien',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'PBSD',
			displayName: 'Phòng ban sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'BPSD',
			displayName: 'Bộ phận sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'TenFileGoc',
			displayName: 'File đính kèm thông tin hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'FileTieuChuan',
			displayName: 'File tiêu chuẩn hàng hóa',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách phòng ban -----------------------*/
	listPB: any[] = [];
	PBUser: string = '';
	selectPB: string = '';
	filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PBFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách NCC -----------------------------*/
	listNCC: any[] = [];
	selectListNCC: string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	arrayNCCForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */

	/*--------------------- Danh sách bộ phận sự dụng --------------------*/
	listPBSD: any[] = [];
	selectListPBSD: string = '';
	filteredListPBSD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListPBSDFilterCtrl: string = '';
	haveElementListPBSD: boolean = false;
	arrayPBSDForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiMuaHang>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	DeNghiMuaHangForm: FormGroup;
	DeNghiMuaHangSubForm: FormGroup;
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	deNghiMuaHangItem: DeNghiMuaHang;
	listChiTietMuaHang: DeNghiMuaHangCT[] = [];
	tmpChiTietMuaHang: DeNghiMuaHangCT[] = [];
	flagFileImport: FileImport = new FileImport();
	flagFileDownload: any;
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	flagTab: number = 0;				// Định danh tab đang chạy
	openTimKiemNangCao = false;
	waittingAddDetail = false;
	optionsLoaiPhieu: any[] = [];
	isCopy: boolean = false;
	isVuotHanMucPB: boolean = false;
	isVuotHanMucDuyet: boolean = false;
	isExistHM: boolean = false;
	isExistHMDuyet: boolean = false;
	hanMucPB: string = '';
	hanMucDuyetPB: string = ''
	haveDataKHMH: boolean = false;
	listDataKeHoachMuaHang: KeHoachMuaHang[] = [];
	idPBMuaHang: number = 0;
	isChange: boolean = false;

	isFromKeHoach: boolean = false;
	idPO: number = -1;
	SoPhieuPO: string = '';
	dataNPLKeHoach: any[] = [];
	dataNPLFull: KhKeHoachSanXuatDuKienNhapXuatInteraction[] = [];
	distanceDate: number = 0;
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<DeNghiMuaHangPageAddEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private deNghiMuaHangService: DeNghiMuaHangPageService,
		private dukienService: DuKienSanXuatService,
		private dungChungService: DungChungService,
		private DeNghiMuaHangFB: FormBuilder,
		private DeNghiMuaHangSubFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load all dropdown and create form */
		this.getIdPBMuaHang();
		this.ListId_HH();
		this.ListState();
		this.ListPB();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.deNghiMuaHangItem = new DeNghiMuaHang();
		this.deNghiMuaHangItem.clear();
		this.optionsLoaiPhieu = DeNghiMuaHang.optionsLoaiPhieu;
		this.createForm();

		let id = this.data.Id;

		if (this.data != null && this.data.isCopy) {
			this.isCopy = this.data.isCopy;
		}

		if (this.data != null && this.data.IsKeHoachMuaHang) {
			this.haveDataKHMH = true;
			this.listDataKeHoachMuaHang = this.data.data;
		}

		if (this.data != null && this.data.isKeHoach) {
			this.isFromKeHoach = true;
			this.dataNPLKeHoach = this.data.dataNPL;
			this.distanceDate = this.data.distanceDate;
		}

		if ((id && id > 0) || this.isCopy) {
			this.deNghiMuaHangItem.Id = id;
			if (this.isCopy) {
				this.deNghiMuaHangItem.Id = this.data.Id;
			}
			this.deNghiMuaHangService.getDetail(this.deNghiMuaHangItem.Id).subscribe(res => {
				if (res.status == 1) {
					this.deNghiMuaHangItem = res.data
					if (res.data.TinhTrang != DeNghiMuaHang.optionsTinhTrang[0].value && !this.isCopy) {
						this.router.navigateByUrl('/404');
					}
					if (this.DeNghiMuaHangForm != null) {
						this.bindingValueAfterCallAPIDetail();
					}
				}
			});
		} else {
			this.deNghiMuaHangItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
			this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(res => {
				if (res.status == 1) {
					this.deNghiMuaHangItem.SoPhieu = res.data;
					if (this.DeNghiMuaHangForm != null)
						this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
					if (this.haveDataKHMH) {
						this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(DeNghiMuaHang.optionsLoaiPhieu[1].value);
						this.listDataKeHoachMuaHang.forEach(x => {
							var _detail = new DeNghiMuaHangCT();
							_detail.clear();
							_detail.MaHang = x.MaHang;
							_detail.TenHang = x.TenHang;
							_detail.QuyCach = x.QuyCach;
							_detail.TenDVT = x.TenDVT;
							_detail.Dvt = x.Dvt;
							_detail.HangHoaId = x.HangHoaId;
							_detail.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[0].value;
							_detail.SoLuong = x.SLDuKienMua;
							_detail.FileImport = new FileImport();
							_detail.FileImport.copy(this.flagFileImport);

							this.flagFileImport.clear();
							this.tmpChiTietMuaHang.push(_detail);
							this.saveAddedCT.push(this.tmpChiTietMuaHang.findIndex(x => x == _detail));

						})
						this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
						this.scrollToBottom();
						this.changeDetectView();
					}
					else if (this.isFromKeHoach) {
						
						this.DeNghiMuaHangForm.controls["DienGiai"].setValue("Mua hàng cho sản xuất");
						this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(DeNghiMuaHang.optionsLoaiPhieu[1].value);
						this.DeNghiMuaHangForm.controls["LoaiPhieu"].disable();
						this.dataNPLKeHoach.forEach(x => {

							let findIndex = this.tmpChiTietMuaHang.findIndex(y => y.HangHoaId == x.HangHoaId);
							if (findIndex > -1) {
								this.tmpChiTietMuaHang[findIndex].SoLuong += +x.DuKienXuat
							}
							else {
								this.idPO = this.data.idPO;
								this.SoPhieuPO = this.data.SoPhieuPO;

								var _detail = new DeNghiMuaHangCT();
								_detail.clear();

								_detail.HangHoaId = x.HhId;
								_detail.MaHang = x.MaHangNPL;
								_detail.TenHang = x.TenHangNPL;

								_detail.Dvt = x.Dvt;
								_detail.TenDVT = x.TenDVTNPL;

								_detail.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[0].value;
								_detail.SoLuong = x.KlXuat;
								_detail.SoLuongDapUng = x.KlTK;
								//_detail.SoLuongDapUng = 0;
								_detail.IdPBSD = this.idPBMuaHang;
								_detail.NguonPhatSinh_Id = this.data.IdKH;
								_detail.NguonPhatSinh_Type = DeNghiMuaHangCT.optionsLoaiPhieuDetail[0].value

								// var fromDate = new Date(this.data.NgaySanXuat);
								// fromDate.setDate(fromDate.getDate() - this.distanceDate);
								// _detail.NgayCanTu = moment(fromDate).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
								_detail.NgayCanTu = this.data.NgaySanXuat;
								_detail.NgayCanDen = this.data.NgaySanXuat;
								_detail.FileImport = new FileImport();
								_detail.FileImport.copy(this.flagFileImport);

								this.deNghiMuaHangService.getMOQ(_detail.HangHoaId).subscribe(res => {
									if (res && res.status === 1) {
										_detail.listMOQ = res.data;
									};
									this.tmpChiTietMuaHang.push(_detail);
									this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
									this.changeDetectView();
								});

								this.flagFileImport.clear();
								this.saveAddedCT.push(this.tmpChiTietMuaHang.findIndex(x => x == _detail));

								let filterTmp = new ReplaySubject<any[]>(1)
								filterTmp.next(this.listPBSD.slice());
								this.arrayPBSDForEachHH.push(filterTmp);								
							}
						})
						this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
						this.scrollToBottom();
						this.changeDetectView();
					}
				}
			});
		}

		this.title = this.getTitle();

		/* Filter list Hang hoa when value change*/
		this.DeNghiMuaHangSubForm.get('MaHang').valueChanges.subscribe(newValue => {
			this.filterId_HH(newValue);
		})

		this.deNghiMuaHangService.data_import.subscribe(res => {
			if (res != null && res != undefined) {
				for (let i = 0; i < res.length; i++) {
					this.flagFileImport = new FileImport();
					this.flagFileImport.clear();
					this.flagFileImport.filename = res[i].fileName;
					this.flagFileImport.extension = res[i].extension;
					this.flagFileImport.base64 = res[i].base64;
				}
			}
		});

		// let breadcrumbs = [{ title: 'Thu mua' }, { title: 'Đề nghị mua hàng', page: '/de-nghi-mua-hang'}, { title: ((this.deNghiMuaHangItem.Id > 0 && !this.isCopy) ? 'Cập nhật' : 'Thêm mới') + ' đề nghị mua hàng' }];
		// this.subheaderService.setBreadcrumbs(breadcrumbs);

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {

			if (event.key == "Escape" && !this.openTimKiemNangCao) {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
				this.onSubmit(1);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode) {
				this.onSubmit(2);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode) {
				this.onSubmit(3);
			}
			this.changeDetectView();
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	ngOnDestroy() {
		this.clearDataImport();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.deNghiMuaHangItem.Nguoitao = +idUser;

		this.DeNghiMuaHangForm = this.DeNghiMuaHangFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState, Validators.required],
			LoaiPhieu: [DeNghiMuaHang.optionsLoaiPhieu[0].value, Validators.required],
			DienGiai: ['', Validators.required],
			TongTien: [DeNghiMuaHang.DEFAULT_NUMBER_VALUE]
		});

		if (this.listState.length > 0) {
			this.checkState();
		}

		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
		this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
		this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
		this.DeNghiMuaHangForm.controls["TrangThai"].disable();
		this.DeNghiMuaHangForm.controls["TongTien"].disable();
		/*------------------------------------------------------------------*/

		this.DeNghiMuaHangSubForm = this.DeNghiMuaHangSubFB.group({
			MaHang: ['', Validators.required],
			TenHang: [''],
			QuyCach: [''],
			DVT: [''],
			SoLuong: [DeNghiMuaHang.DEFAULT_NUMBER_VALUE,
			Validators.compose([Validators.required,
			Validators.min(0.01),
			Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
			],
			PBSD: ['', Validators.required],
			NgayCanTu: [new Date()],
			NgayCanDen: [new Date()],
			GiaDuKien: [DeNghiMuaHang.DEFAULT_NUMBER_VALUE,
			Validators.compose([Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])],
			GhiChu: [''],
			FileName: [''],
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangSubForm.controls["TenHang"].disable();
		this.DeNghiMuaHangSubForm.controls["QuyCach"].disable();
		this.DeNghiMuaHangSubForm.controls["DVT"].disable();
		/*------------------------------------------------------------------*/

		this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail() {
		if (this.deNghiMuaHangItem.Id > 0) {
			if (!this.isCopy) {
				this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
			}
			else {
				this.deNghiMuaHangItem.Id = 0;
				this.deNghiMuaHangItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
				this.deNghiMuaHangItem.listChiTietMuaHang.forEach(x => {
					x.Id = 0;
					x.PhieuDeNghiId = 0;
					x.DaLapDonHang = false;
					x.DaNhanHang = false;
					x.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[0].value
				})

				this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(res => {
					if (res.status == 1) {
						this.deNghiMuaHangItem.SoPhieu = res.data;
						if (this.DeNghiMuaHangForm != null)
							this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(this.deNghiMuaHangItem.SoPhieu);
					}
				});
			}

			this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(this.deNghiMuaHangItem.NgayYeuCau);
			this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(this.deNghiMuaHangItem.TenNguoiTao);
			this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(this.deNghiMuaHangItem.LoaiPhieu);
			this.DeNghiMuaHangForm.controls["DienGiai"].setValue(this.deNghiMuaHangItem.DienGiaiLyDo);
			this.checkState();

			/*Add dữ liệu chi tiết*/
			if (this.deNghiMuaHangItem.listChiTietMuaHang.length > 0) {
				this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
				this.tmpChiTietMuaHang = [];
				for (let i = 0; i < this.listChiTietMuaHang.length; i++) {
					if (this.listChiTietMuaHang[i].SoLuongDaMua == null) {
						this.listChiTietMuaHang[i].SoLuongDaMua = 0;
					}
					if (this.listChiTietMuaHang[i].SoLuongDaNhan == null) {
						this.listChiTietMuaHang[i].SoLuongDaNhan = 0;
					}
					let tmpElement = new DeNghiMuaHangCT();
					tmpElement.copy(this.listChiTietMuaHang[i])
					this.deNghiMuaHangService.getMOQ(tmpElement.HangHoaId).subscribe(res => {
						if (res && res.status === 1) {
							tmpElement.listMOQ = res.data;
						};
					});
					this.tmpChiTietMuaHang.push(tmpElement);

					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listPBSD.slice());
					this.arrayPBSDForEachHH.push(filterTmp);
				}
				this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
				this.updateTT();
			}
		}
	}
	getTitle(): string {
		if (this.deNghiMuaHangItem.Id > 0 && !this.isCopy) {
			return `Chỉnh sửa phiếu đề nghị mua hàng`;
		}
		return 'Thêm mới phiếu đề nghị mua hàng';
	}
	getTrangThaiDetail(state: string) {
		let item = DeNghiMuaHangCT.optionTrangThaiDetail.find(x => x.value == state)
		if (item != null) {
			return item.name;
		}
		return '';
	}
	changeLoaiPhieu() {
		this.isVuotHanMucDuyet = false;
		this.isVuotHanMucPB = false;

		if (this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[1].value) {
			this.DeNghiMuaHangSubForm.controls["PBSD"].setValue('' + this.idPBMuaHang);
			this.DeNghiMuaHangSubForm.controls["PBSD"].disable();
		}
		else {
			this.DeNghiMuaHangSubForm.controls["PBSD"].setValue('');
			this.DeNghiMuaHangSubForm.controls["PBSD"].enable();
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState() {
		this.dungChungService.listState(DeNghiMuaHang.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.deNghiMuaHangItem.TinhTrang) {
				this.nameState = element.Description;
				if (this.DeNghiMuaHangForm != null)
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListId_HH() {
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	afterSelectHH(value: string) {
		this.listId_HH.forEach(element => {
			if (element.Id_HH == +value) {
				this.selectId_HH = value;
				this.DeNghiMuaHangSubForm.controls["MaHang"].setValue(element.MaHH);
				this.DeNghiMuaHangSubForm.controls["MaHang"].disable();
				this.DeNghiMuaHangSubForm.controls["TenHang"].setValue(element.TenHH);
				this.DeNghiMuaHangSubForm.controls["QuyCach"].setValue(element.QuyCach);
				this.DeNghiMuaHangSubForm.controls["DVT"].setValue(element.TenDVT);
				this.getHanMucDuyetPhongBan(this.DeNghiMuaHangSubForm.controls['PBSD'].value, element.IdLoaiHH);
			}
		});

		this.isDisableButton();
	}
	getIDLoaiHH() {
		let item = this.listId_HH.find(x => x.Id_HH == +this.selectId_HH)
		if (item != null) {
			return item.IdLoaiHH;
		}
		return 0;
	}
	clearSelectHH(event: any) {
		this.selectId_HH = '';
		this.DeNghiMuaHangSubForm.controls["MaHang"].setValue('');
		this.DeNghiMuaHangSubForm.controls["MaHang"].enable();

		this.DeNghiMuaHangSubForm.controls["TenHang"].setValue('');
		this.DeNghiMuaHangSubForm.controls["QuyCach"].setValue('');
		this.DeNghiMuaHangSubForm.controls["DVT"].setValue('');

		this.sumRecord = this.listId_HH.length;
		if (event != null)
			event.stopPropagation();
		this.isDisableButton();
	}

	ListPB() {
		this.dungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPBSD = res.data;
				this.filteredListPBSD.next(this.listPBSD.slice());
				this.changeDetectView();
			};
		});
	}
	filterPB() {
		if (!this.listPBSD) {
			return;
		}
		let search = this.PBFilterCtrl;
		if (!search) {
			this.filteredListPBSD.next(this.listPBSD.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListPBSD.next(
			this.listPBSD.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	getHanMucPhongBan(idPB: number) {
		var isKeHoach = this.checkDKGetHMPB();
		this.dungChungService.getHanMucPhongBanTheoDK(idPB, isKeHoach).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.isExistHM = true;
				this.hanMucPB = res.data;
				if (this.hanMucPB == null || this.hanMucPB == '' || this.hanMucPB == '0') {
					this.hanMucPB = '0'
					this.isExistHM = false;
				}
				this.calculateVuotHanMuc();
				this.changeDetectView();
			}
		});
	}
	getHanMucDuyetPhongBan(idPB: number, idLoaiHH: number) {
		this.dungChungService.getHanMucDuyetPhongBan(idPB, idLoaiHH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.isExistHMDuyet = true;
				this.hanMucDuyetPB = res.data;
				if (this.hanMucDuyetPB == null || this.hanMucDuyetPB == '' || this.hanMucDuyetPB == '0') {
					this.hanMucDuyetPB = '0'
					this.isExistHMDuyet = false;
				}
				this.calculateVuotHanMuc();
				this.changeDetectView();
			};
		});
	}
	getIdPBMuaHang() {
		this.deNghiMuaHangService.getConfigDefaultPB().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.idPBMuaHang = res.data;
				if (this.haveDataKHMH && this.tmpChiTietMuaHang.length > 0) {
					this.tmpChiTietMuaHang.forEach(x => {
						x.IdPBSD = this.idPBMuaHang;
					})
				}
				this.changeDetectView();
			};
		});
	}
	checkDKGetHMPB() {
		if (this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[0].value) {
			return false;
		}
		return true;
	}
	checkErrorHMPB(type: boolean, subType: boolean) {
		if (this.DeNghiMuaHangSubForm.controls['PBSD'].value != null &&
			this.DeNghiMuaHangSubForm.controls['PBSD'].value != '') {
			if (Number(this.hanMucPB) == 0 && type && subType) {
				return true;
			}
			else if ((Number(this.hanMucPB) > 0) && type && !subType) {
				return true;
			}
			else if (Number(this.hanMucPB) == 0 && !type && subType) {
				return true;
			}
			else if ((Number(this.hanMucPB) > 0) && !type && !subType) {
				return true;
			}
		}
		return false
	}
	checkShowErrorHMDuyet(type: boolean) {
		if (this.DeNghiMuaHangSubForm.controls['PBSD'].value != null &&
			this.DeNghiMuaHangSubForm.controls['PBSD'].value != '') {
			if (Number(this.hanMucDuyetPB) == 0 && type)
				return true;
			else if ((Number(this.hanMucDuyetPB) > 0) && !type)
				return true;
		}
		return false;
	}
	calculateVuotHanMuc() {
		let sum = this.f_number(this.DeNghiMuaHangSubForm.controls["SoLuong"].value) *
			this.f_number(this.DeNghiMuaHangSubForm.controls["GiaDuKien"].value);

		if (sum > Number(this.hanMucPB)) {
			this.isVuotHanMucPB = true;
		}
		else {
			this.isVuotHanMucPB = false;
		}

		if (sum > Number(this.hanMucDuyetPB)) {
			this.isVuotHanMucDuyet = true;
		}
		else {
			this.isVuotHanMucDuyet = false;
		}
	}
	updateTT() {
		let sum = 0;
		this.tmpChiTietMuaHang.forEach(x => {
			sum += Number(x.ThanhTien);
		})
		this.DeNghiMuaHangForm.controls['TongTien'].setValue(this.f_number(sum));
	}
	checkMOQItem(item: DeNghiMuaHangCT){
		if(item && item.HangHoaId > 0 && item.NccId > 0){
			let hhItem = this.listId_HH.find(x => x.Id_HH == +item.HangHoaId);
			let moqItem = item.listMOQ.find(x => x.IdHH == +item.HangHoaId && x.IdNcc == +item.NccId);
			if(hhItem && moqItem){
				if(hhItem.DVT == moqItem.MOQ_DVT && moqItem.MOQ > item.SoLuong){
					return true;
				}
				else if(hhItem.Dvt2 && hhItem.QuiDoiDVT2 && hhItem.Dvt2 == moqItem.MOQ_DVT){
					let convert = moqItem.MOQ * hhItem.QuiDoiDVT2;
					if(convert > item.SoLuong)
						return true;
				}
				else if(hhItem.Dvt3 && hhItem.QuiDoiDVT3 && hhItem.Dvt3 == moqItem.MOQ_DVT){
					let convert = moqItem.MOQ * hhItem.QuiDoiDVT3;
					if(convert > item.SoLuong)
						return true;
				}
			}
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiMuaHang.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiMuaHangCT) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	changeSLOfItem(index: number) {
		if (Number(this.tmpChiTietMuaHang[index].SoLuong) > 0 && Number(this.tmpChiTietMuaHang[index].GiaDuKien) > 0) {
			this.tmpChiTietMuaHang[index].ThanhTien = (Number(this.tmpChiTietMuaHang[index].SoLuong) * Number(this.tmpChiTietMuaHang[index].GiaDuKien)).toString();
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	compareDate(firstVal: any, secondVal: any) {
		if (firstVal != null && firstVal != undefined && secondVal != null && secondVal != undefined) {
			let d1 = new Date(firstVal);
			let d2 = new Date(secondVal);
			if (d1.getTime() > d2.getTime())
				return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	isDisableButton() {

		if (this.DeNghiMuaHangSubForm.invalid ||
			this.DeNghiMuaHangSubForm.controls["TenHang"].value == null ||
			this.DeNghiMuaHangSubForm.controls["TenHang"].value == '') {
			this.disableNewButton = true;
		}
		else {
			this.disableNewButton = false;
		}

	}
	isChangeTTPhieu() {
		let isChange = false;
		if (this.deNghiMuaHangItem.Id > 0) {
			if (this.DeNghiMuaHangForm.controls["LoaiPhieu"].value != this.deNghiMuaHangItem.LoaiPhieu) {
				isChange = true
				return isChange;
			}
			if (this.DeNghiMuaHangForm.controls["DienGiai"].value != this.deNghiMuaHangItem.DienGiaiLyDo) {
				isChange = true
				return isChange;
			}

			let isAllnew = false;
			this.tmpChiTietMuaHang.forEach(x => {
				if (x.Id == 0) {
					isAllnew = true;
				}
			})
			if (isAllnew && this.deNghiMuaHangItem.Id > 0)
				return true;

			if (this.deNghiMuaHangItem.listChiTietMuaHang.length != this.tmpChiTietMuaHang.length) {
				isChange = true
				return isChange;
			}

		}
		else {
			var phongban = '';
			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

			if (this.DeNghiMuaHangForm.controls["LoaiPhieu"].value != DeNghiMuaHang.optionsLoaiPhieu[0].value
				|| (this.DeNghiMuaHangForm.controls["DienGiai"].value != null && this.DeNghiMuaHangForm.controls["DienGiai"].value != '')
				|| this.tmpChiTietMuaHang.length > 0) {
				isChange = true;
			}
		}
		return isChange;
	}
	back() {
		if (!this.isChangeTTPhieu()) {
			this.dialogRef.close(
				{
					isChange: this.isChange,
					dataAdd: this.saveAdded,
				}
			);
		}
		else {
			const dialogRef = this.layoutUtilsService.POPConfirm('Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				else{
					this.dialogRef.close(
						{
							isChange: this.isChange,
							dataAdd: this.saveAdded,
						}
					);
				}
			});
		}
	}
	deleteItem(item: any) {
		const index = this.tmpChiTietMuaHang.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietMuaHang.splice(index, 1);
			this.arrayPBSDForEachHH.splice(index, 1);
		}
		this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
		this.updateTT();
	}
	addDetail() {
		this.waittingAddDetail = true;
		const controls = this.DeNghiMuaHangSubForm.controls;
		const _detail = new DeNghiMuaHangCT();
		_detail.clear();

		if (this.compareDate(controls['NgayCanTu'].value, controls['NgayCanDen'].value)) {
			this.layoutUtilsService.showErorr('Ngày cần không thể lớn hơn ngày đến');
			this.scrollToBottom();
			return null;
		}

		this.listId_HH.forEach(element => {
			if (element.Id_HH == +this.selectId_HH) {
				_detail.MaHang = element.MaHH;
				_detail.TenHang = element.TenHH;
				_detail.QuyCach = element.QuyCach;
				_detail.TenDVT = element.TenDVT;
				_detail.Dvt = element.DVT;
			}
		})

		_detail.HangHoaId = +this.selectId_HH;
		_detail.SoLuong = this.f_number(controls['SoLuong'].value);
		_detail.IdPBSD = Number(controls['PBSD'].value);
		_detail.TenPBSD = this.listPBSD.findIndex(x => x.Id_PB == _detail.IdPBSD) > -1 ? this.listPBSD.find(x => x.Id_PB == _detail.IdPBSD).TenPB : '';
		_detail.GhiChu = controls["GhiChu"].value;
		_detail.GiaDuKien = this.f_number(controls['GiaDuKien'].value);
		_detail.TrangThaiMatHang = DeNghiMuaHangCT.optionTrangThaiDetail[0].value
		_detail.FileImport = new FileImport();
		_detail.FileImport.copy(this.flagFileImport);
		_detail.fileTmpDownLoad = this.flagFileDownload;
		// _detail.NccId = Number(controls['MOQ'].value);
		// _detail.listMOQ = [...this.listMOQ];

		this.flagFileDownload = null;
		this.flagFileImport.clear();

		if (controls["NgayCanTu"].value != null && controls["NgayCanTu"].value != '')
			_detail.NgayCanTu = moment(new Date(controls["NgayCanTu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');

		if (controls["NgayCanDen"].value != null && controls["NgayCanDen"].value != '')
			_detail.NgayCanDen = moment(new Date(controls["NgayCanDen"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');

		if (Number(_detail.SoLuong) > 0 && Number(_detail.GiaDuKien) > 0) {
			_detail.ThanhTien = (Number(_detail.SoLuong) * Number(_detail.GiaDuKien)).toString();
		}

		this.DeNghiMuaHangSubForm.reset();
		this.DeNghiMuaHangSubForm.controls["MaHang"].enable();
		this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
		this.DeNghiMuaHangSubForm.controls["GiaDuKien"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
		this.DeNghiMuaHangSubForm.controls["NgayCanTu"].setValue(new Date());
		this.DeNghiMuaHangSubForm.controls["NgayCanDen"].setValue(new Date());
		this.changeLoaiPhieu();
		this.hanMucDuyetPB = '0';
		this.hanMucPB = '0';
		this.isVuotHanMucDuyet = false;
		this.isVuotHanMucPB = false;

		this.selectId_HH = '';
		this.filteredId_HH.next(this.listId_HH.slice());

		this.tmpChiTietMuaHang.push(_detail);
		this.saveAddedCT.push(this.tmpChiTietMuaHang.findIndex(x => x == _detail));

		this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
		this.disableNewButton = true;
		this.waittingAddDetail = false;

		let filterTmp = new ReplaySubject<any[]>(1)
		filterTmp.next(this.listPBSD.slice());
		this.arrayPBSDForEachHH.push(filterTmp);

		this.updateTT();
		this.scrollToBottom();
		this.changeDetectView();
	}
	addMoreHH() {
		const dialogRef = this.dialog.open(AddHangHoaComponent, {
			data: null,
			width: '60%',
		});

		dialogRef.afterClosed().subscribe(res => {

			if (res == undefined || res == null) {
				return;
			}
			else {
				if (res.data != null && res.data != undefined) {
					this.ListId_HH();
					this.selectId_HH = res.data.Id_HH;
					this.DeNghiMuaHangSubForm.controls["MaHang"].setValue(res.data.MaHH);
					this.DeNghiMuaHangSubForm.controls["MaHang"].disable();
					this.DeNghiMuaHangSubForm.controls["TenHang"].setValue(res.data.TenHH);
					this.DeNghiMuaHangSubForm.controls["DVT"].setValue(res.data.TenDVT);
					this.isDisableButton();
				}
			}
		});
	}
	onSubmit(type: number) {
		;
		const controls = this.DeNghiMuaHangForm.controls;

		if (this.DeNghiMuaHangForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			window.scrollTo({ top: 0, behavior: 'smooth' });
			return false;
		}

		if (this.tmpChiTietMuaHang.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng đề nghị mua');
			this.scrollToBottom();
			return null;
		}

		for (var i = 0; i < this.tmpChiTietMuaHang.length; i++) {
			if (this.compareDate(this.tmpChiTietMuaHang[i].NgayCanTu, this.tmpChiTietMuaHang[i].NgayCanDen)) {
				this.layoutUtilsService.showErorr('Mã hàng: ' + this.tmpChiTietMuaHang[i].MaHang + ' - Ngày cần không thể lớn hơn ngày đến');
				this.scrollToBottom();
				return null;
			}
			// if(this.checkMOQItem(this.tmpChiTietMuaHang[i])){
			// 	this.layoutUtilsService.showErorr('Mã hàng: ' + this.tmpChiTietMuaHang[i].MaHang + ' - Số lượng phải >= MOQ');
			// 	this.scrollToBottom();
			// 	return null;
			// }
		}

		// this.tmpChiTietMuaHang.forEach(x => {
		// 	x.NgayCanTu = moment(new Date(x.NgayCanTu)).add(7, 'hours').format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		// 	x.NgayCanDen = moment(new Date(x.NgayCanDen)).add(7, 'hours').format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		// 	x.fileTmpDownLoad = null;
		// })

		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

		const _result = new DeNghiMuaHang();
		_result.clear();
		_result.SoPhieu = controls["SoPhieu"].value;
		_result.LoaiPhieu = controls["LoaiPhieu"].value;
		_result.LoaiHangHoaYeuCau = 3;
		_result.NgayYeuCau = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.PhongBanId = +phongban;
		_result.DienGiaiLyDo = controls["DienGiai"].value;
		_result.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
		_result.listChiTietMuaHang = [...this.tmpChiTietMuaHang];

		if (type == 1 || type == 2) {
			_result.TinhTrang = DeNghiMuaHang.optionsTinhTrang[1].value;
		}

		if (type == 1 || type == 2) {
			const dialogRef = this.layoutUtilsService.POP02(_result.SoPhieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				_result.listChiTietMuaHang.forEach(x => {
					x.NgayCanTu = moment(new Date(x.NgayCanTu)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
					x.NgayCanDen = moment(new Date(x.NgayCanDen)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
					x.fileTmpDownLoad = null;
				})
				if (this.deNghiMuaHangItem.Id > 0) {
					_result.Id = this.deNghiMuaHangItem.Id;
					this.update(_result, type);
					return;
				}
				this.add(_result, type);
			});
		}
		else {
			_result.listChiTietMuaHang.forEach(x => {
				x.NgayCanTu = moment(new Date(x.NgayCanTu)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				x.NgayCanDen = moment(new Date(x.NgayCanDen)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				x.fileTmpDownLoad = null;
			})
			if (this.deNghiMuaHangItem.Id > 0) {
				_result.Id = this.deNghiMuaHangItem.Id;
				this.update(_result, type);
				return;
			}
			this.add(_result, type);
		}
	}
	update(item: DeNghiMuaHang, withBack: number) {
		this.deNghiMuaHangService.updateWithDetail(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu đề nghị mua hàng cập nhật thành công`;
				this.layoutUtilsService.showInfo(message);

				let index = this.saveAdded.findIndex(x => x == res.data.Id);
				if (index == -1)
					this.saveAdded.push(res.data.Id);
				this.deNghiMuaHangService.dataNew$.next(this.saveAdded)

				if (withBack == 1) {
					this.dialogRef.close(
						{
							isChange: this.isChange,
							dataAdd: this.saveAdded,
						}
					);
				}
				else {
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
					this.clearDataImport();

					if (withBack == 2) {
						this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(resNextSP => {
							if (resNextSP.status == 1) {

								this.DeNghiMuaHangForm.reset();

								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

								var phongban = '';
								this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

								this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(resNextSP.data);
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
								this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(DeNghiMuaHang.optionsLoaiPhieu[0].value);
								this.DeNghiMuaHangForm.controls["TongTien"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);

								/*Disable các trường dữ liệu không thay đổi */
								this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
								this.DeNghiMuaHangForm.controls["TrangThai"].disable();
								this.DeNghiMuaHangForm.controls["TongTien"].disable();

								this.DeNghiMuaHangSubForm.reset();
								this.DeNghiMuaHangSubForm.controls["MaHang"].enable();
								this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
								this.DeNghiMuaHangSubForm.controls["GiaDuKien"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
								this.DeNghiMuaHangSubForm.controls["NgayCanTu"].setValue(new Date());
								this.DeNghiMuaHangSubForm.controls["NgayCanDen"].setValue(new Date());

								this.selectId_HH = '';
								this.filteredId_HH.next(this.listId_HH.slice());
								this.sumRecord = this.listId_HH.length;
								this.isVuotHanMucPB = false;

								this.listChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];

								this.deNghiMuaHangItem.Id = 0;
								this.deNghiMuaHangItem.SoPhieu = resNextSP.data;
								this.title = this.getTitle();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if (withBack == 3) {
						this.deNghiMuaHangService.getDetail(this.deNghiMuaHangItem.Id).subscribe(res => {
							if (res.status == 1) {
								this.deNghiMuaHangItem = res.data;
								if (this.deNghiMuaHangItem.listChiTietMuaHang.length > 0) {
									this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
									this.tmpChiTietMuaHang = [];
									for (let i = 0; i < this.listChiTietMuaHang.length; i++) {
										if (this.listChiTietMuaHang[i].SoLuong == null) {
											this.listChiTietMuaHang[i].SoLuong = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										if (this.listChiTietMuaHang[i].SoLuongDaMua == null) {
											this.listChiTietMuaHang[i].SoLuongDaMua = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										if (this.listChiTietMuaHang[i].SoLuongDaNhan == null) {
											this.listChiTietMuaHang[i].SoLuongDaNhan = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										let tmpElement = new DeNghiMuaHangCT();
										tmpElement.copy(this.listChiTietMuaHang[i])
										this.deNghiMuaHangService.getMOQ(tmpElement.HangHoaId).subscribe(res => {
											if (res && res.status === 1) {
												tmpElement.listMOQ = res.data;
											};
										});
										this.tmpChiTietMuaHang.push(tmpElement);
									}

									this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
								}
								this.changeDetectView();
							}
						});
						this.isCopy = false;
					}
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	add(item: DeNghiMuaHang, withBack: number) {
		this.deNghiMuaHangService.add(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu đề nghị mua hàng mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);

				let index = this.saveAdded.findIndex(x => x == res.data.Id);
				if (index == -1)
					this.saveAdded.push(res.data.Id);
				this.deNghiMuaHangService.dataNew$.next(this.saveAdded)

				this.isChange = true;
				if (withBack == 1) {
					this.dialogRef.close(
						{
							isChange: this.isChange,
							dataAdd: this.saveAdded,
						}
					);
				}
				else {
					this.selectId_HH = '';
					this.filteredId_HH.next(this.listId_HH.slice());
					this.clearDataImport();

					if (withBack == 2) {
						this.dungChungService.getBillNumber(DeNghiMuaHang.category_path).subscribe(res => {
							if (res.status == 1) {

								this.DeNghiMuaHangForm.reset();

								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

								var phongban = '';
								this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

								this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(res.data);
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
								this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(DeNghiMuaHang.optionsLoaiPhieu[0].value);
								this.DeNghiMuaHangForm.controls["TongTien"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);

								/*Disable các trường dữ liệu không thay đổi */
								this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
								this.DeNghiMuaHangForm.controls["TrangThai"].disable();
								this.DeNghiMuaHangForm.controls["TongTien"].disable();

								this.DeNghiMuaHangSubForm.reset();
								this.DeNghiMuaHangSubForm.controls["MaHang"].enable();
								this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
								this.DeNghiMuaHangSubForm.controls["GiaDuKien"].setValue(DeNghiMuaHang.DEFAULT_NUMBER_VALUE);
								this.DeNghiMuaHangSubForm.controls["NgayCanTu"].setValue(new Date());
								this.DeNghiMuaHangSubForm.controls["NgayCanDen"].setValue(new Date());

								this.selectId_HH = '';
								this.filteredId_HH.next(this.listId_HH.slice());
								this.sumRecord = this.listId_HH.length;
								this.isVuotHanMucPB = false;

								this.listChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];

								this.deNghiMuaHangItem.SoPhieu = res.data;
								this.changeDetectView();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if (withBack == 3) {
						this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
						this.deNghiMuaHangItem.Id = res.data.Id;
						this.deNghiMuaHangService.getDetail(this.deNghiMuaHangItem.Id).subscribe(res => {
							if (res.status == 1) {
								this.deNghiMuaHangItem = res.data;
								if (this.deNghiMuaHangItem.listChiTietMuaHang.length > 0) {
									this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
									this.tmpChiTietMuaHang = [];
									for (let i = 0; i < this.listChiTietMuaHang.length; i++) {
										if (this.listChiTietMuaHang[i].SoLuong == null) {
											this.listChiTietMuaHang[i].SoLuong = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										if (this.listChiTietMuaHang[i].SoLuongDaMua == null) {
											this.listChiTietMuaHang[i].SoLuongDaMua = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										if (this.listChiTietMuaHang[i].SoLuongDaNhan == null) {
											this.listChiTietMuaHang[i].SoLuongDaNhan = Number(DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER);
										}
										let tmpElement = new DeNghiMuaHangCT();
										tmpElement.copy(this.listChiTietMuaHang[i])
										this.deNghiMuaHangService.getMOQ(tmpElement.HangHoaId).subscribe(res => {
											if (res && res.status === 1) {
												tmpElement.listMOQ = res.data;
											};
										});
										this.tmpChiTietMuaHang.push(tmpElement);
									}

									this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
								}
								this.changeDetectView();
							}
						});
						this.isCopy = false;
					}
					this.title = this.getTitle();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	openHistoryMuaHangDialog(item: DeNghiMuaHangCT) {
		const dialogRef = this.dialog.open(LichSuMuaHangDialogComponent, {
			data: {
				data: item.Id,
				MaHH: item.MaHang,
				TenHH: item.TenHang
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	openHistoryNhanHangDialog(item: DeNghiMuaHangCT) {
		const dialogRef = this.dialog.open(LichSuNhanHangDialogComponent, {
			data: {
				data: item.Id,
				MaHH: item.MaHang,
				TenHH: item.TenHang
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	callDetail() {
		var item = new KDDatHang();
		item.IdDH = this.idPO;
		const dialogRef = this.dialog.open(KDDatHangEditComponent, {
			data: {
				data: item,
				chi_tiet: true,
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe();
	}
	/* -----------------------------------------------------------------------*/


	/*--------------------------- Hàm xử lý File------------------------------*/
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {

			let fileNameList = [];
			for (let i = 0; i < evt.target.files.length; i++) {
				let file = evt.target.files[i];
				this.flagFileDownload = file;
				let fileName = file.name;
				fileNameList.push(fileName);
			}
			let listFileNameStr = fileNameList[0];
			for (var i = 1; i < fileNameList.length; i++) {
				listFileNameStr += ', ' + fileNameList[i];
			}
			this.DeNghiMuaHangSubForm.controls["FileName"].setValue(listFileNameStr);

			let el: any = this.fileUpload.nativeElement;
			var service = this.deNghiMuaHangService;
			var useBase64: boolean = true;
			let tmpDataArray: any = [];

			for (var idx = 0; idx < el.files.length; idx++) {
				var extension = el.files[idx].name.split('.').pop();
				var fileName = el.files[idx].name.substring(0, el.files[idx].name.indexOf(extension) - 1);

				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');

					base64Str = base64Str.substr(metaIdx + 8);
					var data = {
						fileName: fileName,
						base64: base64Str,
						extension: extension
					};

					tmpDataArray.push(data);
					service.data_import.next(tmpDataArray);
				};
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	clearDataImport() {
		this.deNghiMuaHangService.data_import.next([]);
	}
	downloadFile(idctdn: number, item: DeNghiMuaHangCT) {
		if (idctdn > 0) {
			let linkdownload = this.deNghiMuaHangService.downloadTemplate(idctdn);
			window.open(linkdownload);
		}
		else {
			let objectURL;
			const file = item.fileTmpDownLoad;
			objectURL = URL.createObjectURL(file);
			var downloadLink = document.createElement("a");
			downloadLink.href = objectURL;
			downloadLink.download = file.name;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		}

	}
	/* -----------------------------------------------------------------------*/

	/*------------------------------ Extend Options --------------------------*/
	timKiemNangCao() {
		this.openTimKiemNangCao = true;

		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw: this.focusDetail.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}
	tabChange(event: MatTabChangeEvent) {
		if (event.index == 0)
			this.flagTab = 0;
		else if (event.index == 1)
			this.flagTab = 1;
		this.clearDataImport();
		this.changeDetectView();
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/
}